import './FieldsPreview.css';
import { Link } from "react-router-dom";
import RouteUrl from '../RouteEnum';

const FieldsPreview = ({ field }) => {
    const [number, ...rest] = field.title1.split('.');
    const cleanTitle = rest.length>0 ? rest.join('.') : number;
    return (
        <Link to={"../" + RouteUrl.medicalFields + (field.url_address ? field.url_address : field.pk)} relative="path">
            <div className="preview" >
                <img src={field.icon} />
                <h4 style={{ margin: "10px" }}>{cleanTitle.split('|')[0]}</h4>
            </div>
        </Link>
    );
};

export default FieldsPreview;